import styles from './FilterTitle.module.css'

const FilterTitle = ({ title }: { title: string }): JSX.Element => (
  <span className={styles.title}>{title}</span>
)

export default FilterTitle
